/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProductTypeEnum } from '../../models/product-type-enum';

export interface ProductGetType$Plain$Params {
  productId?: string;
}

export function productGetType$Plain(http: HttpClient, rootUrl: string, params?: ProductGetType$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ProductTypeEnum>> {
  const rb = new RequestBuilder(rootUrl, productGetType$Plain.PATH, 'get');
  if (params) {
    rb.query('productId', params.productId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ProductTypeEnum>;
    })
  );
}

productGetType$Plain.PATH = '/api/Product/type';
